import { Routes, Route } from 'react-router-dom';
import { DashboardPage } from '@features/dashboard/DashboardPage';
import { AnalysisPage } from '@features/analysis/AnalysisPage';
import { ReportsPage } from '@features/reports/ReportsPage';
import { Layout } from '@shared/Layout';

export function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/analysis" element={<AnalysisPage />} />
                <Route path="/reports" element={<ReportsPage />} />
            </Route>
        </Routes>
    );
}
